import { Injectable } from '@angular/core';
import { FilterData } from '../components/busqueda/busqueda.component';
import { ListadoDocumentoPaginado } from '../models/Document';
import { ParticipantesType } from '../models/ParticipantesType';

@Injectable({
  providedIn: 'root'
})
export class BusquedaStateService {
  filterData: FilterData | null = null;
  documentsPaginated: ListadoDocumentoPaginado | null = null;
  participantes: ParticipantesType | null = null;
  pageIndex: number = 0;

  hasState(): boolean {
    return this.filterData !== null && this.documentsPaginated !== null;
  }

  save(filterData: FilterData, documentsPaginated: ListadoDocumentoPaginado, participantes: ParticipantesType, pageIndex: number) {
    this.filterData = { ...filterData };
    this.documentsPaginated = { ...documentsPaginated };
    this.participantes = { ...participantes };
    this.pageIndex = pageIndex;
  }

  clear() {
    this.filterData = null;
    this.documentsPaginated = null;
    this.participantes = null;
    this.pageIndex = 0;
  }
}